<div class="p-5 flex flex-col h-full overflow-hidden">
	<div class="mb-6 flex items-center justify-between">
		<div class="flex items-center justify-between w-full">
			<h2>Accounting</h2>
			<div class="flex gap-x-2">
				<p *ngIf="!accountingExport && !isLeapEnabled" class="m-auto">
					File has not been printed or exported yet
				</p>
				<p *ngIf="accountingExport" class="m-auto">
					{{
						accountingExport.exportingType === AccountingExportingTypes.EXPORT
							? 'Exported'
							: 'Printed'
					}}
					by {{ userName }} on
					{{ accountingExport.lastExportedAt | date: 'medium' }}
				</p>
				<app-button
					*ngIf="!isLeapEnabled"
					intercomAttr="intercom-accounting-print-btn"
					[icon]="ICON.PRINT"
					btn="secondary"
					size="small"
					(click)="print()"
					>Print</app-button
				>
				<app-button
					intercomAttr="intercom-accounting-export-btn"
					[icon]="ICON.EXPORT"
					btn="primary"
					size="small"
					(click)="export()"
					>{{ isLeapEnabled ? 'Export to LEAP' : 'Export' }}</app-button
				>
			</div>
		</div>
	</div>

	<div class="mt-2 mb-4 flex justify-between items-center">
		<div class="col-span-2">
			<app-anchor
				type="static"
				[icon]="ICON.EXTERNAL"
				[url]="statementOfAccountUrl"
				intercomAttr="anchor-to-statement-of-account"
				>View Statement of Account</app-anchor
			>
		</div>
		<img
			*ngIf="isCosmolexEnabled"
			class="w-[120px] h-[20px]"
			src="/assets/images/integrations/cosmolex-logo.png"
			alt="Cosmolex logo"
		/>
		<img
			*ngIf="isSolunoEnabled"
			class="w-[135px] h-[30px]"
			src="/assets/images/integrations/soluno-logo.png"
			alt="Soluno logo"
		/>
		<img
			*ngIf="isGhostPracticeEnabled"
			class="w-[135px] h-[30px]"
			src="/assets/images/integrations/ghost-practice-logo.png "
			alt="GhostPractice logo"
		/>
		<img
			*ngIf="isLeapEnabled"
			class="w-[135px] h-[29px]"
			src="assets/images/leap/leap-logo-primary-soa.png"
		/>
	</div>
	<div class="grid grid-cols-2 gap-x-6 gap-y-4 min-h-0 overflow-auto">
		<ng-container *ngIf="isCosmolexEnabled">
			<app-cosmolex class="col-span-2"></app-cosmolex>
		</ng-container>

		<ng-container *ngIf="isSolunoEnabled">
			<app-soluno class="col-span-2"></app-soluno>
		</ng-container>

		<ng-container *ngIf="isGhostPracticeEnabled">
			<app-ghost-practice class="col-span-2"></app-ghost-practice>
		</ng-container>

		<ng-container *ngIf="isLeapEnabled">
			<app-leap-accounting class="col-span-2"></app-leap-accounting>
		</ng-container>
	</div>
</div>
